import { defaultConfig, TenantConfig } from './default';

export function getConfig(): TenantConfig {
  const config = { ...defaultConfig };
  const { formConfig: purchaseOrderFormConfig } = config.purchaseOrderEntryFlow;
  purchaseOrderFormConfig.poCostDiscount.active = true;
  return config;
}
